import { DataTableHeader, DataTableStatusBadge } from "components/DataTable";
import { IPoliceman, IUpdatePolicemen } from "interfaces/Policeman";
import { DashboardFlex } from "./styles";
import { FindOptionsWhere } from "interfaces/IQuery";

export type IPolicemanWhereFilters = Array<FindOptionsWhere<IPoliceman>> | FindOptionsWhere<IPoliceman>

export const updatePolicemanTableColumns: DataTableHeader<IUpdatePolicemen>[] = [
  { field: 'policeman', label: 'Pronta-resposta', renderColumn: (data) => data.user.name },
  { 
    field: 'policeman', 
    label: 'Enviado em', 
    renderColumn: (data) =>
    new Date(data.createdAt).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }), 
  },
]

export const allPolicemanTableColumns: DataTableHeader<IPoliceman>[] = [
  {
    field: "active",
    label: "Registro",
    type: "status",
    renderColumn: (data) => {
      if (!data.approved) {
        return (
          <DashboardFlex>
            <DataTableStatusBadge variant="warning">
              Para aprovação
            </DataTableStatusBadge>
          </DashboardFlex>
        );
      }

      return undefined;
    },
  },
  {
    field: 'region',
    label: 'Região preferida',
  },
  {
    field: "createdAt",
    label: "Data de criação",
    renderColumn: (data) =>
      new Date(data.createdAt).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
  },
  {
    field: "updatedAt",
    label: "Data de modificação",
    renderColumn: (data) =>
      new Date(data.updatedAt).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
  },
  {
    field: "sigInAt",
    label: "Último acesso",
    renderColumn: (data) =>
      data.sigInAt
        ? new Date(data.sigInAt).toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
        : "Nunca",
  },
  {
    field: "salary",
    label: "A receber",
    renderColumn: (data) =>
      data.salary.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      }),
  },
]

export const toApprovePolicemanTableColumns: DataTableHeader<IPoliceman>[] = [
    {
    field: "user",
    label: "Nome do pronta-resposta",
    renderColumn: (data) => data.user.name,
  },
  {
    field: "active",
    label: "Registro",
    type: "status",
    renderColumn: (data) => {
      if (!data.approved) {
        return (
          <DashboardFlex>
            <DataTableStatusBadge variant="warning">
              Para aprovação
            </DataTableStatusBadge>
          </DashboardFlex>
        );
      }

      return undefined;
    },
  },
  {
    field: "createdAt",
    label: "Registro enviado em",
    renderColumn: (data) =>
      new Date(data.createdAt).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
  },
  {
    field: 'region',
    label: 'Região preferida',
  },
  {
    field: 'publicAgent',
    label: 'É agente público?',
    type: 'boolean'
  },
  {
    field: 'working',
    label: 'Está na ativa?',
    type: 'boolean'
  },
]